<template>
    <div class="container lg:p-0">
        <SectionIntro
            :title="$t('star_map.page.title')"
            class="mt-16"
            :subtitle="$t('star_map.page.subtitle')"
            xl
        />
        <MapProductSwitch :products="starMapProducts" />
        <star-map-editor :testimonials="testimonials" />
        <div v-if="!$cookies.get('is-star-map-editor-instructions-seen')">
            <EditorInstructionsModal
                cookie="is-star-map-editor-instructions-seen"
                :start-index="instructionSteps.length - 1"
                :steps="instructionSteps"
                carousel-id="star-map-instructions-carousel"
            />
        </div>
    </div>
</template>

<script>
import StarMapEditor from '@/components/Editor/StarMap/Editor.vue';
import EditorInstructionsModal from '@/components/Modals/EditorInstructionsModal.vue';
import MapProductSwitch from '@/components/Editor/Shared/MapProductSwitch.vue';
import { STAR_MAP_PRODUCTS } from '@/components/Editor/Shared/productOptions';
export default {
    components: {
        StarMapEditor,
        EditorInstructionsModal,
        MapProductSwitch,
    },
    async asyncData({ $axios, error }) {
        let testimonials = [];
        try {
            await $axios
                .get('/testimonials')
                .then((res) => {
                    if (res.data.result !== 'success') return;
                    testimonials = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }
        return { testimonials };
    },
    data() {
        return {
            gallery: null,
            starMapProducts: STAR_MAP_PRODUCTS,
        };
    },
    computed: {
        instructionSteps() {
            return [1, 2, 3, 4, 5].map((id) => ({
                id,
                title: this.$t(`star_map.instructions.step_${id}.title`),
                description: this.$t(`star_map.instructions.step_${id}.description`),
                illustration: `star-map-step_${id}.webp`,
            }));
        },
    },
};
</script>
